//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      show: false,
      radio: "",
      seDataSelect:[
        {
          radio:'1',
          name:'1',
          title:"单选框1"
        },
        {
          radio:'2',
          name:'2',
          title:"单选框2"
        },
      ],
      
      getRadio:'',
      valueContent:'---请选择---',
      changeData:''
    };
  },
  methods: {
    showPopup() {
      this.show = true;
    },

    onAddressClick() {
      // this.$router.push("/pages/00_Tpl/Template2/02_CreateAdd/main");
    },

    se_colse(){
      this.show = false;
    },

    com_confrim(){
      this.show = false;
      this.valueContent = this.changeData
    },

    selectRadio(event){
     this.changeData = this.seDataSelect[event].title
    }
  },
  created() {},
  mounted() {}
};
